import { forOwn } from 'lodash'

export default class Model {
  constructor(payload) {
    forOwn(payload, (value, key) => {
      this[key] = value
    })
  }

  translateField(field, locale) {
    const fr = 'fr'
    const en = 'en'
    return field ? field[locale] || field[fr] || field[en] : null
  }
}
